export default __webpack_public_path__ + "static/media/Dr-preethi-nayak.b9419de9.jpg";